export const transportMeta: Record<
  string,
  {
    icon: [string, string]
    type: 'primary' | 'warning' | 'success' | 'info' | 'danger' | 'default'
    label: string
    color: string
  }
> = {
  telegram: {
    icon: ['fab', 'telegram'],
    type: 'primary',
    label: 'Telegram',
    color: '#409EFF'
  },
  widget: {
    icon: ['fas', 'comments'],
    type: 'warning',
    label: 'Widget',
    color: '#E6A23C'
  },
  plain_email: {
    icon: ['fas', 'envelope'],
    type: 'warning',
    label: 'Email',
    color: '#E6A23C'
  }
}

export const transportIcon = (transport: string): [string, string] =>
  transportMeta[transport]?.icon || ['fas', 'question-circle']

export const transportType = (
  transport: string
): 'primary' | 'warning' | 'success' | 'info' | 'danger' | 'default' =>
  transportMeta[transport]?.type || 'default'

export const transportLabel = (transport: string): string =>
  transportMeta[transport]?.label || ''
